import React, { useCallback } from 'react';

const ArchivedBulletinAnnuelCompetence = ({ bulletin, competences }) => {
	const getNotesForBulletinAndCompetence = useCallback(
		(bulletinTrimestrielId, competenceId) => {
			if (bulletin && bulletin.bulletins_trimestriels) {
				const trimestriels = bulletin.bulletins_trimestriels.find(
					(bulletinTrim) => bulletinTrim.id === bulletinTrimestrielId
				);
				if (trimestriels) {
					const note = trimestriels.notes_trimestrielles.find(
						(note) => note.competence === competenceId
					);
					if (note) {
						// Arrondir les valeurs à 2 chiffres après la virgule
						return {
							...note,
							note_ecrit: note.note_ecrit ? note.note_ecrit.toFixed(2) : null,
							note_oral: note.note_oral ? note.note_oral.toFixed(2) : null,
							note_pratique: note.note_pratique
								? note.note_pratique.toFixed(2)
								: null,
							note_savoir_etre: note.note_savoir_etre
								? note.note_savoir_etre.toFixed(2)
								: null,
							note_total: note.note_total ? note.note_total.toFixed(2) : null,
							note_matiere: note.note_matiere
								? note.note_matiere.toFixed(2)
								: null
						};
					}
				}
			}
			return null; // Return null if no notes are found or if the arrays are empty
		},
		[bulletin]
	);

	const getAverageForBulletinAndCompetence = useCallback(
		(notesAnnuelles, bulletinId, competenceId) => {
			// Trouver l'entrée correspondante dans notes_annuelles pour la compétence donnée et bulletin donné
			const noteAnnuelle = notesAnnuelles.find(
				(note) =>
					note.bulletin_annuel === bulletinId &&
					note.competence === competenceId
			);

			// Si on trouve une note correspondante, renvoyer les valeurs nécessaires, sinon renvoyer null
			if (noteAnnuelle) {
				return {
					note_ecrit: noteAnnuelle.note_ecrit
						? noteAnnuelle.note_ecrit.toFixed(2)
						: 0,
					note_oral: noteAnnuelle.note_oral
						? noteAnnuelle.note_oral.toFixed(2)
						: 0,
					note_pratique: noteAnnuelle.note_pratique
						? noteAnnuelle.note_pratique.toFixed(2)
						: 0,
					note_savoir_etre: noteAnnuelle.note_savoir_etre
						? noteAnnuelle.note_savoir_etre.toFixed(2)
						: 0,
					note_total: noteAnnuelle.note_total
						? noteAnnuelle.note_total.toFixed(2)
						: 0,
					grade: noteAnnuelle.grade
				};
			}
			return null;
		},
		[]
	);

	return (
		<div>
			{bulletin && competences && competences.length > 0 ? (
				<>
					<table className="table table-sm table-light table-bordered">
						<thead>
							<tr className="align-middle">
								<th
									className="text-uppercase align-middle fw-bold"
									style={{ width: '60%', color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'COMPETENCES'
										: 'COMPETENCE'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? '1er Trim'
										: '1st Term'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? '2e Trim'
										: '2nd Term'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? '3e Trim'
										: '3rd Term'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moy. Annuelle'
										: 'Annual'}
								</th>
							</tr>
						</thead>
						<tbody>
							{competences.map(
								(competence) =>
									competence && (
										<React.Fragment key={competence.id}>
											<tr>
												<td className="text-uppercase align-middle">
													{bulletin.salledeclasse_details.section === 'fr'
														? `${competence.nom} - (${competence.total_points} pts)`
														: `${competence.nom} - (${competence.total_points} mks)`}
												</td>
												{bulletin.bulletins_trimestriels
													.sort((a, b) => a.trimestre - b.trimestre)
													.map((bulletin_trimestriels, index) => {
														const notes = bulletin
															? getNotesForBulletinAndCompetence(
																	bulletin_trimestriels.id,
																	competence.id
															  )
															: null;
														return (
															<td
																className="text-center"
																key={
																	bulletin ? bulletin_trimestriels.id : index
																}
															>
																{notes ? notes.note_total : ''}
															</td>
														);
													})}
												{Array.from({
													length: 3 - bulletin.bulletins_trimestriels.length
												}).map((_, index) => (
													<td
														className="text-center"
														key={`empty-${index}`}
													></td>
												))}
												<td className="text-center">
													{bulletin.notes_annuelles &&
														(() => {
															const notes = getAverageForBulletinAndCompetence(
																bulletin.notes_annuelles,
																bulletin.id,
																competence.id
															);
															return notes ? notes.note_total : '';
														})()}
												</td>
											</tr>
										</React.Fragment>
									)
							)}
							<tr>
								<td className="text-uppercase align-middle fw-bold">
									TOTAL (
									{bulletin.total_points_annuel !== null &&
									bulletin.total_points_annuel !== undefined
										? bulletin.total_points_annuel
										: ''}{' '}
									PTS )
								</td>
								{bulletin.bulletins_trimestriels
									.sort((a, b) => a.trimestre - b.trimestre)
									.map((bulletin_trimestriels, index) => {
										return (
											<td
												className="text-center"
												key={
													bulletin_trimestriels
														? bulletin_trimestriels.id
														: index
												}
											>
												{bulletin_trimestriels.total_obtenu !== undefined
													? bulletin_trimestriels.total_obtenu.toFixed(2)
													: ''}
											</td>
										);
									})}
								{Array.from({
									length: 3 - bulletin.bulletins_trimestriels.length
								}).map((_, index) => (
									<td className="text-center" key={`empty-${index}`}></td>
								))}

								<td className="text-center">
									{bulletin.total_obtenu !== null &&
									bulletin.total_obtenu !== undefined
										? bulletin.total_obtenu.toFixed(2)
										: ''}
								</td>
							</tr>
						</tbody>
					</table>

					<table className="table table-sm table-light table-bordered mt-4">
						<thead>
							<tr>
								<th
									colSpan="11"
									className="text-center text-dark fw-bold"
									style={{ backgroundColor: '#b1b1b1' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'STATISTIQUES DE PERFORMANCES'
										: 'PERFORMANCE STATISTICS'}
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moyenne 1er Trimestre'
										: '1st Trimester Average'}
								</th>
								<th colSpan="2" className="text-center">
									{bulletin.bulletins_trimestriels
										.sort((a, b) => a.trimestre - b.trimestre)[0]
										?.moyenne_generale?.toFixed(2) || ''}
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moyenne 2e Trimestre'
										: '2nd Trimester Average'}
								</th>
								<th colSpan="2" className="text-center">
									{bulletin.bulletins_trimestriels
										.sort((a, b) => a.trimestre - b.trimestre)[1]
										?.moyenne_generale?.toFixed(2) || ''}
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moyenne 3e Trimestre'
										: '3rd Trimester Average'}
								</th>
								<th colSpan="2" className="text-center">
									{bulletin.bulletins_trimestriels
										.sort((a, b) => a.trimestre - b.trimestre)[2]
										?.moyenne_generale?.toFixed(2) || ''}
								</th>
							</tr>

							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? "Moyenne annuelle de l'élève"
										: 'Annual appreciation'}
								</th>
								<th colSpan="2" className="text-center">
									{bulletin.moyenne_generale?.toFixed(2) || ''}
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Appreciation annuelle de la classe'
										: 'Annual Class Average'}
								</th>
								<th colSpan="2" className="text-center">
									{bulletin.moyenne_classe?.toFixed(2) || ''}
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Taux de réussite de la classe'
										: 'Percentage passed'}
								</th>
								<th colSpan="2" className="text-center">
									{bulletin.pourcentage_reussite?.toFixed(2) || ''} %
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Admis(e)'
										: 'Promoted'}
								</th>
								<th colSpan="2" className="text-center">
									<input
										type="checkbox"
										readOnly
										checked={bulletin.moyenne_generale >= 10}
										style={{ transform: 'scale(1.5)', accentColor: 'black' }}
									/>
								</th>
							</tr>
							<tr>
								<th colSpan="9">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Redouble'
										: 'Repeated'}
								</th>
								<th colSpan="2" className="text-center">
									<input
										type="checkbox"
										readOnly
										checked={bulletin.moyenne_generale < 10}
										style={{
											transform: 'scale(1.5)',
											accentColor: 'black'
										}}
									/>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr className="align-middle">
								<th
									colSpan="11"
									className="text-center text-dark fw-bold"
									style={{ backgroundColor: '#b1b1b1' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'OBSERVATION'
										: 'OBSERVATION'}
								</th>
							</tr>
							<tr className="align-middle">
								<th colSpan="2">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Observations du titulaire'
										: "Teacher's Remarks"}
								</th>
								<th colSpan="3">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Observations disciplinaires'
										: 'Appreciations'}
								</th>
								<th colSpan="3">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Signature des parents'
										: "Parent's Signature"}
								</th>
								<th colSpan="3">
									{bulletin.salledeclasse_details.section === 'fr'
										? "Signature du chef de l'établissement"
										: "Headteacher's Signature"}
								</th>
							</tr>
							<tr>
								<td colSpan="2" style={{ height: '120px' }}></td>
								<td colSpan="3" style={{ height: '120px' }}></td>
								<td colSpan="3" style={{ height: '120px' }}></td>
								<td colSpan="3" style={{ height: '120px' }}></td>
							</tr>
						</tbody>
					</table>
				</>
			) : (
				<div>
					Chargement des notes de l'élève pour le bulletin annuel (Bulletin
					Competences)...
				</div>
			)}
		</div>
	);
};

export default ArchivedBulletinAnnuelCompetence;
